import React from 'react';
import { FreezerContent } from '../components/FreezerContent';
import { FreezerCountdown } from '../components/FreezerCountdown';
import { FreezerHero } from '../components/FreezerHero';
import { FreezerOffers } from '../components/FreezerOffers';
export function LandingPage() {
  const scrollToOffers = () => {
    document.getElementById('ofertas')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <main className="min-h-screen w-full bg-brand-dark font-sans text-white selection:bg-brand-violet/30" data-id="element-230" data-mp="2az9ei31bvqpx">
      <FreezerHero onViewOffer={scrollToOffers} data-id="element-231" data-mp="260y49r74fe76" />
      <FreezerContent data-id="element-232" data-mp="2kygr2o08nhbz" />
      <FreezerCountdown data-id="element-233" data-mp="2kz0ak95jeds4" />
      <FreezerOffers data-id="element-234" data-mp="2ky8detwak7zq" />
    </main>;
}